/**
 * Copilot Toast — interrupting surface
 * ═══════════════════════════════════════════════════════════════
 * Phase 2 · task 2.15 (surface 5 of 5)
 *
 * The only surface that appears without being asked, which is why it defaults
 * OFF per copilot and only ever renders a trigger rule that has fired. It
 * auto-dismisses, because a suggestion that demands action is an interruption
 * twice over.
 */
import { useEffect } from 'react';
import { Sparkles, X } from 'lucide-react';

export default function CopilotToast({ trigger, agentName, onDismiss, onAccept, autoDismissMs = 12000 }) {
  useEffect(() => {
    if (!trigger) return undefined;
    const t = setTimeout(() => onDismiss?.(trigger.id), autoDismissMs);
    return () => clearTimeout(t);
  }, [trigger, autoDismissMs, onDismiss]);

  if (!trigger) return null;

  return (
    <div className="fixed bottom-24 right-6 z-[9991] w-72 rounded-2xl border border-gray-200
                    bg-white shadow-xl overflow-hidden animate-in slide-in-from-bottom-2">
      <div className="flex items-start gap-2.5 p-3.5">
        <div className="h-7 w-7 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600
                        flex items-center justify-center text-white shrink-0">
          <Sparkles size={12} />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-[12px] font-semibold text-gray-800">{trigger.label}</p>
          {trigger.prompt && <p className="text-[11px] text-gray-600 mt-0.5">{trigger.prompt}</p>}
          <div className="flex items-center gap-2 mt-2">
            <button
              onClick={() => onAccept?.(trigger)}
              className="text-[11px] font-medium text-blue-600 hover:text-blue-700"
            >
              Yes, help
            </button>
            <button
              onClick={() => onDismiss?.(trigger.id)}
              className="text-[11px] text-gray-400 hover:text-gray-600"
            >
              Not now
            </button>
          </div>
          {agentName && <p className="text-[9px] text-gray-300 mt-1.5">from {agentName}</p>}
        </div>
        <button
          onClick={() => onDismiss?.(trigger.id)}
          className="text-gray-300 hover:text-gray-500 shrink-0"
          aria-label="Dismiss"
        >
          <X size={12} />
        </button>
      </div>
    </div>
  );
}
